import React from 'react';
import Confetti from 'react-confetti';
import useDimensions from 'react-use-dimensions';
import styled from '@marvelapp/styled';
import { colors } from '@marvelapp/theme';
import { Box, Button, Flex, Heading, Text } from '@marvelapp/ui';
const confettiColors = [
    colors.tealLight,
    colors.purpleLight,
    colors.yellowLight,
    colors.orangeLight,
    colors.greenLight,
];
export default function ConfettiSuccessMessage({ buttonTitle = 'Back to dashboard', children, footerContent, heading, onButtonClick, text, }) {
    const [ref, { width, height }] = useDimensions();
    return (React.createElement(Flex, { minHeight: "100%", width: "100%" },
        React.createElement(Flex, { alignItems: "center", flex: 1, flexDirection: "column", justifyContent: ['flex-start', 'flex-start', 'center'] },
            React.createElement(Box, { borderRadius: [0, 0, 3], boxShadow: ['none', 'none', 'button.ghost'], maxWidth: 420, mb: footerContent ? [0, 0, 6] : 0, width: "100%" },
                React.createElement(Box, { bordeRradius: "8px 8px 0 0", display: ['none', 'none', 'block'], height: 140, overflow: "hidden", position: "relative", ref: ref },
                    React.createElement(Confetti, { colors: confettiColors, height: height, width: width }),
                    React.createElement(Gradient, null)),
                React.createElement(Box, { pb: [5, 5, 6], px: [0, 0, 6] },
                    React.createElement(Heading, { as: "h1", fontSize: 6, lineHeight: 1.5, mb: 3, textAlign: ['center', 'center', 'left', 'left'] }, heading),
                    React.createElement(Text, { as: "p", fontSize: 3, mb: 3, textAlign: ['center', 'center', 'left', 'left'] }, text),
                    React.createElement(Text, { as: "p", fontSize: 3, textAlign: ['center', 'center', 'left', 'left'] }, children),
                    React.createElement(Flex, { justifyContent: ['center', 'center', 'left', 'left'], mt: 4 },
                        React.createElement(Button, { kind: "marvel", onClick: onButtonClick, size: 3 }, buttonTitle)))),
            footerContent)));
}
const Gradient = styled.div `
  position: absolute;
  z-index: 3;
  bottom: 0;
  left: 1px;
  right: 1px;
  height: 30px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
`;
